// zoom.animations.ts
import { trigger, state, style, animate, transition } from '@angular/animations';

export const zoomInAnimation = trigger('zoomIn', [
  state('void', style({ transform: 'scale(0.5)' })),
  transition('void => *', animate('500ms ease-in-out')),
]);

export const zoomOutAnimation = trigger('zoomOut', [
  state('*', style({ transform: 'scale(1)' })),
  transition('* => void', animate('500ms ease-in-out')),
]);
